import { render, staticRenderFns } from "./InactiveNotice.vue?vue&type=template&id=60734240"
import script from "./InactiveNotice.vue?vue&type=script&lang=ts"
export * from "./InactiveNotice.vue?vue&type=script&lang=ts"
import style0 from "./InactiveNotice.vue?vue&type=style&index=0&id=60734240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports